import { z } from 'zod';

export const RefundReasonSchema = z.enum([
  'CUSTOMER_REQUEST',
  'DUPLICATE_ORDER',
  'EVENT_CANCELLED',
  'SYSTEM_ERROR',
  'OTHER',
]);
export type RefundReason = z.infer<typeof RefundReasonSchema>;

export const AdminRefundStatusSchema = z.enum([
  'PENDING_APPROVAL',
  'APPROVED',
  'PROCESSING',
  'COMPLETED',
  'REJECTED',
  'FAILED',
]);
export type AdminRefundStatus = z.infer<typeof AdminRefundStatusSchema>;

export const CreateRefundSchema = z.object({
  amount: z.number().positive(),
  reason: RefundReasonSchema,
  notes: z.string().min(1).max(1000),
  policyChecked: z.boolean(),
});
export type CreateRefundInput = z.infer<typeof CreateRefundSchema>;

export const AdminRefundSchema = z.object({
  id: z.string(),
  orderId: z.string(),
  amount: z.number(),
  reason: RefundReasonSchema,
  reasonLabel: z.string(),
  notes: z.string(),
  status: AdminRefundStatusSchema,
  policyChecked: z.boolean(),
  requiresApproval: z.boolean(),
  approvedBy: z.string().optional(),
  approvedAt: z.string().optional(),
  processedAt: z.string().optional(),
  createdBy: z.string(),
  createdAt: z.string(),
  midtransRefundId: z.string().optional(),
});
export type AdminRefund = z.infer<typeof AdminRefundSchema>;

export const AdminRefundsListResponseSchema = z.object({
  refunds: z.array(AdminRefundSchema),
});
export type AdminRefundsListResponse = z.infer<typeof AdminRefundsListResponseSchema>;
